import * as types from "../actions/index";
export default function(state = null, action) {
  switch (action.type) {
    case types.SHOW_TIMEOUT_POPUP:
      return action.payload;

    // no default
  }
  return state;
}
